import { faqBreadcrumb, defBreadcrumb } from "../../../data/DataBreadcrumb";
import Questions from "../../../components/Faq/Questions";
import fetch from "../../../utils/fetch";
import { pertanyaanUmumMeta } from "../../../data/DataMetatags";
import React from "react";
import TopicWrapperProps from "../../../components/Faq/TopicWrapper";

const TopicId = ({
  asPath,
  breadcrumb,
  topicBreadcrumb,
  questions,
  pageTitle,
  description,
  topicId,
  faqTitle,
  faqData,
  header
}) => {
  return (
    <TopicWrapperProps
      pageTitle={pageTitle}
      asPath={asPath}
      description={description}
      breadcrumb={breadcrumb}
      topicBreadcrumb={topicBreadcrumb}
      questions={questions}
      topicId={topicId}
      header={header}
    >
      <Questions data={faqData} title={faqTitle} topicId={topicId} />
    </TopicWrapperProps>
  );
};

TopicId.getInitialProps = async ({ res, query, asPath }) => {
  const { title, description } = pertanyaanUmumMeta;
  const { topicId, header } = query;
  const topic_id = topicId.replace(/-/g, "_");

  const questions = await fetch("GET", "/kentico/questions");
  if (questions.status === 200) {
    const { status, data } = await fetch("GET", "/kentico/topic-faq", {
      topicId: topic_id
    });
    if (status === 200) {
      const pageTitle = `${title} - ${data.title}`;

      const breadcrumb = [
        ...defBreadcrumb,
        {
          "@type": "ListItem",
          position: "2",
          item: {
            "@id": process.env.baseUrl + "/pertanyaan-umum",
            name: "pertanyaan-umum"
          }
        },
        {
          "@type": "ListItem",
          position: "3",
          item: {
            "@id": process.env.baseUrl + `/pertanyaan-umum/${topicId}`,
            name: pageTitle
          }
        }
      ];

      const topicBreadcrumb = [
        ...faqBreadcrumb,
        {
          page: data.title,
          href: asPath,
          to: `/pertanyaan-umum/${topicId}`
        }
      ];

      return {
        asPath,
        breadcrumb,
        topicBreadcrumb,
        questions: questions.data,
        pageTitle,
        description,
        topicId,
        faqTitle: data.title,
        faqData: data.data,
        header
      };
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?q=pertanyaan-umum/${topic_id}`
        });
        res.end();
      }
    }
  } else {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?q=pertanyaan-umum`
      });
      res.end();
    }
    return;
  }
};

export default TopicId;
